import { BlockTypes } from '@/types'

import { readonly } from 'vue'

import PostModel from '@/models/PostModel'
import GiftCardModel from '@/models/GiftCardModel'

export const MAX_SELECTED_POSTS = 3
export const DEFAULT_POST = readonly(
  PostModel.mergeTogether({
    name: 'Пост не задан',
  })
)
export const DEFAULT_GIFTCARD = readonly(
  GiftCardModel.mergeTogether({
    name: 'Сертификат отсутствует',
  })
)

export const MAX_SELECTED_PRODUCTS = 14
export const MAX_SELECTED_PRESETS = 10

export const BLOCKS_ROUTES_SELECT = readonly<
  Partial<Record<BlockTypes, { name: string; params?: Record<string, any> }>>
>({
  [BlockTypes.Banner1]: {
    name: 'manager-blocks-banners',
    params: { type: BlockTypes.Banner1 },
  },
  [BlockTypes.Banner2]: {
    name: 'manager-blocks-banners',
    params: { type: BlockTypes.Banner2 },
  },
  [BlockTypes.Banner3]: {
    name: 'manager-blocks-banners',
    params: { type: BlockTypes.Banner3 },
  },
  [BlockTypes.Banner4]: {
    name: 'manager-blocks-banners',
    params: { type: BlockTypes.Banner4 },
  },
  [BlockTypes.Posts]: {
    name: 'manager-blocks-posts',
  },
  [BlockTypes.ProductsFeed]: {
    name: 'manager-blocks-products',
  },
  [BlockTypes.CatalogsFeed]: {
    name: 'manager-blocks-presets',
  },
})

export const CURTAIN_BLOCKS = [
  { type: BlockTypes.Banner1, name: '1 баннер', classProp: '' },
  { type: BlockTypes.Banner2, name: '2 баннера', classProp: '' },
  { type: BlockTypes.Banner3, name: '3 баннера', classProp: '' },
  { type: BlockTypes.Banner4, name: '4 баннера', classProp: '' },
  { type: BlockTypes.Posts, name: 'Блог', classProp: '' },
  {
    type: BlockTypes.ProductsFeed,
    name: 'Товарный фид',
    classProp: '',
  },
  {
    type: BlockTypes.CatalogsFeed,
    name: 'Каталожный фид',
    classProp: '',
  },
]
